import React, { Children, cloneElement } from 'react';

export interface CustomWorkflowComponentProps {
    children: React.ReactElement[];
    currentStep: string;
    showFooter?: boolean;
}

export const CustomWorkflowComponent: React.FC<CustomWorkflowComponentProps> = (props) => {
    const { currentStep, showFooter = true, children } = props;

    const childMustBeShown = (child: React.ReactElement) =>
        child.props.step === currentStep ? cloneElement(child, { showFooter }) : undefined;

    return Children.map(children, childMustBeShown);
};
